@if (order) {
  <div class="state-indicator cursor-pointer mr-1 ml-1"
    [matTooltip]="getOrderTooltip(order)"
    matTooltipClass="mtooltip"
     [ngClass]="{
                  'wait-file': order.state === OrderState.WAIT_FILES && !order.disabled,
                  'bat-refused': order.state === OrderState.BAT_REFUSED && !order.disabled,
                  'bat-accepted': order.state === OrderState.BAT_ACCEPTED && !order.disabled,
                  'bat-to-validate': order.state === OrderState.WAIT_BAT && !order.disabled,
                  'bat-process': order.state === OrderState.PROCESSING && !order.disabled,
                  'production': order.state === OrderState.PRODUCTION && !order.disabled,
                  'shipped': order.state === OrderState.SHIPPED && !order.disabled,
                  'invoicing': order.state === OrderState.INVOICING && !order.disabled,
                  'finished': order.state === OrderState.FINISHED && !order.disabled,
                  'order-disabled': order.state === OrderState.NEW_ORDER || order.disabled }">
  </div>
}
@if (shipmentGroup) {
  <div class="state-indicator cursor-pointer mr-1 ml-1"
    [matTooltip]="getShipmentGroupTooltip(shipmentGroup) | translate"
    matTooltipClass="'tooltip'"
     [matMenuTriggerFor]="authService.hasRole(RolesEnum.SHIPMENT_WRITE) &&
     [ShipmentStateEnum.IN_TRANSIT, ShipmentStateEnum.DELIVERED, ShipmentStateEnum.CANCELLED
     , ShipmentStateEnum.TO_COLLECT]
     .includes(shipmentGroup.state) ?
     shipmentGroupStateMenu : null"
     [ngClass]="{
                'to-ship': shipmentGroup.state === ShipmentStateEnum.TO_SHIP,
                'planned': shipmentGroup.state === ShipmentStateEnum.PLANNED,
                'to-collect': shipmentGroup.state === ShipmentStateEnum.TO_COLLECT,
                'in-transit': shipmentGroup.state === ShipmentStateEnum.IN_TRANSIT,
                'delivered': shipmentGroup.state === ShipmentStateEnum.DELIVERED,
                'cancelled': shipmentGroup.state === ShipmentStateEnum.CANCELLED
                 }">
    <mat-menu #shipmentGroupStateMenu="matMenu">
      <div class="px-4 pt-4" (click)="$event.stopPropagation()">
        <mat-form-field>
          <mat-label>{{ 'status' | translate }}</mat-label>
          <mat-select [(ngModel)]="shipmentGroup.state" (selectionChange)="updateState($event, shipmentGroup)">
            <mat-option
              [value]="ShipmentStateEnum.IN_TRANSIT">{{ 'shipment.state.inTransit' | translate }}
            </mat-option>
            <mat-option
              [value]="ShipmentStateEnum.DELIVERED">{{ 'shipment.state.delivered' | translate }}
            </mat-option>
            <mat-option
              [value]="ShipmentStateEnum.CANCELLED">{{ 'shipment.state.cancelled' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-menu>
  </div>
}
@if (quotation) {
  <div class="state-indicator cursor-pointer mr-1 ml-1"
    [matTooltip]="getQuotationTooltip(quotation) | translate"
    matTooltipClass="'tooltip'"
     [ngClass]="{
                'new': quotation['state'] === QuotationState.NEW,
                'submitted': quotation['state'] === QuotationState.SUBMITTED,
                'accepted': quotation['state'] === QuotationState.ACCEPTED,
                'refused': quotation['state'] === QuotationState.REFUSED,
                'canceled': quotation['state'] === QuotationState.CANCELED
                 }">
  </div>
}
@if (externalProduction) {
  <div class="state-indicator cursor-pointer mr-1 ml-1"
    [matTooltip]="getExternalProductionTooltip(externalProduction) | translate"
    matTooltipClass="'tooltip'"
     [ngClass]="{
                'new': externalProduction['state'] === ExternalProductionState.NEW,
                'bat-process': externalProduction['state'] === ExternalProductionState.WAITING,
                'production': externalProduction['state'] === ExternalProductionState.PROGRESS,
                'accepted': externalProduction['state'] === ExternalProductionState.ACCEPTED,
                'finished': externalProduction['state'] === ExternalProductionState.FINISHED,
                'canceled': externalProduction['state'] === ExternalProductionState.CANCELLED,
                 }">
  </div>
}
@if (subcontractRequest) {
  <div class="state-indicator cursor-pointer mr-1 ml-1"
    [matTooltip]="getSubcontractRequestTooltip(subcontractRequest)"
    matTooltipClass="'tooltip'"
     [ngClass]="{
                'new': subcontractRequest.state === SubcontractRequestState.NEW,
                'bat-process': subcontractRequest.state === SubcontractRequestState.WAITING,
                'bat-refused': subcontractRequest.state  === SubcontractRequestState.REFUSED,
                'accepted': subcontractRequest.state  === SubcontractRequestState.ACCEPTED,
                'canceled': subcontractRequest.state  === SubcontractRequestState.CANCELED,
                 }">
  </div>
}
